import React, { useCallback, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAutoB, GetHeaderStyle } from "../../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";

import { textFilter } from "react-bootstrap-table2-filter";

function UserSettingPopup(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.editor;
  const { selectedRow, setUpdateFlag } = props;
  const [data, setData] = useState(null);
  const [dataX] = props.dataComponent;
  const [searchStateA, setSearhStateA] = props.searchState;
  const [searchB, setSearchB] = props.searchB;

  const refForm1 = useRef(null);
  const dispatch = useDispatch();
  //----------------------------------------------------------------------

  useEffect(() => {
    if (selectedRow) {
      getData(() => {
        selectedRow.action("ready");
      });
    }
  }, [selectedRow]);

  //----------------------------------------------------------------------
  const getData = (goReady) => {
    if (selectedRow && selectedRow.row && selectedRow.row.userid < 1) {
      setData({
        brchid: -1,
        brchshort: "",
        rulid: 0,
        staff_fullname: "",
        staffid: -1,
        userid: -1,
        username: "",
        pws: "default",
      });
      goReady();
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/user/get-user-data",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          setData(res.data.rows[0]);
          goReady();
        }
      })
      .catch((err) =>
        dispatch(setReminder({ show: true, message: err.message }))
      );
  };

  //----------------------------------------------------------------------
  //Saving Data TO server
  const saveData = (evt) => {
    const dForm1 = new FormData(refForm1.current);
    const fData1 = Object.fromEntries(dForm1);
    if (fData1.pws1 != fData1.pws2) {
      dispatch(
        setReminder({
          show: true,
          message: (
            <p>
              รหัสผ่านไม่ตรงกัน..
              <br />
              กรุณาลองใหม่
            </p>
          ),
          type: "error",
        })
      );
      return;
    }
    if (fData1.pws1 === "") {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาตรวจสอบรหัสผ่าน",
          type: "error",
        })
      );
      return;
    }
    if (data.brchid < 0) {
      dispatch(
        setReminder({
          show: true,
          message: (
            <p>
              ยังไม่ได้เลือกสาขา..
              <br />
              กรุณาลองใหม่
            </p>
          ),
          type: "error",
        })
      );
      return;
    }
    if (data.staffid < 0) {
      dispatch(
        setReminder({
          show: true,
          type: "error",
          message: (
            <p>
              ยังไม่ไดเลือกเจ้าหน้าที่..
              <br />
              กรุณาลองใหม่
            </p>
          ),
        })
      );
      return;
    }

    let dataToSave = {
      ItemId: selectedRow.row["userid"],
      SaveInfo: { ...fData1, staffid: data.staffid, brchid: data.brchid },
      UserInfo: userDetail,
    };

    if (selectedRow.patrightid === 0) {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        createby: userDetail.userid,
      };
    } else {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        updateby: userDetail.userid,
      };
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/user/update-web-data",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({
            show: true,
            type: "success",
            message: "บันทึกสมบูรณ์",
          })
        );
        setWinState({ show: false });
        setUpdateFlag(true);
      })
      .catch((err) => {
        let msg = err.response.data.msg;
        dispatch(
          setReminder({
            show: true,
            type: "error",
            message: (
              <p>
                {msg}
                <br />
                ไม่สามารถใช้ Username นี้ได้
              </p>
            ),
          })
        );
      });
  };

  //----------------------------------------------------------------------
  const SearchStaff = () => {
    setSearchB({
      show: true,
      size: "lg", //*
      fieldId: "staffid", //*
      fieldName: "itemName", //*
      sql: {
        fields: [
          "a.staffid itemId",
          "a.staffcode itemCode",
          " concat(p.shortname,a.firstname,space(3),a.lastname) itemName ",
          "b.stafftypeshort itemShort",
        ],
        tableName:
          " ba_staff a " +
          "inner join ba_staff_type b on a.stafftypeid = b.stafftypeid and b.del_flag='n' and b.flag_radi_dummy='n' " +
          "inner join sy_prefix p on a.prefixid = p.prefixid and p.del_flag ='n' ",
        defaultCriteria: " a.del_flag='n'",
        criteriaFields: ["a.firstname", "a.lastname"],
        criteriaText: "",
        orderBy: ["a.firstname"],
        maxRows: 1000,
      },
      action: (item) => {
        if (data) {
          data.staffid = item?.itemId;
          data.staff_fullname = item?.itemName;
          if (!data.username) {
            data.username = item?.itemCode;
          }
          setSearchB((pv) => ({ ...pv, show: false }));
        }
      },
      columns: [
        {
          dataField: "itemCode",
          text: "รหัสพนักงาน",
          sort: true,
          headerStyle: GetHeaderStyle("120px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemName",
          text: "ชื่อ-สกุล",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemShort",
          text: "แผนก",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
      ],
    });
  };
  //----------------------------------------------------------------------
  const SearchBranch = () => {
    setSearhStateA({
      show: true,
      sql: {
        fields: ["a.brchid itemId, brchshort itemName "],
        tableName: " ba_branch a ",
        defaultCriteria: " a.del_flag='n'",
        criteriaFields: ["a.brchshort"],
        criteriaText: "",
        orderBy: ["a.brchshort"],
        maxRows: 1000,
      },
      action: (item) => {
        if (data) {
          setData((pv) => {
            pv.brchid = item.itemId;
            pv.brchshort = item.itemName;
            return { ...pv };
          });
          //data.brchid = item.itemId;
          //data.brchshort = item.itemName;
          setSearhStateA({ show: false });
        }
      },
    });
  };
  //----------------------------------------------------------------------
  // FIELDS Ojbect list
  const FILEDS = [
    { label: "ชื่อเข้าใช้งาน", oName: "username", require: true, type: "text" },
    {
      label: "กลุ่มผู้ใช้",
      oName: "ruleid",
      type: "select",
      rows: dataX && dataX.Rules,
    },
    {
      label: "เจ้าหน้าที่",
      oName: "staff_fullname",
      type: "find",
      click: SearchStaff,
      refKey: null,
      refValue: null,
    },
    {
      label: "สาขา",
      oName: "brchshort",
      type: "find",
      click: SearchBranch,
      refKey: null,
      refValue: null,
    },

    { label: "รหัสผ่าน", oName: "pws1", require: true, type: "password" },
    { label: "ยืนยันรหัสผ่าน", oName: "pws2", require: true, type: "password" },
  ];
  //----------------------------------------------------------------------
  // Return Zone
  return (
    <MyModal
      show={winState.show}
      size="lg"
      centered
      backdrop={false}
      onHide={() => setWinState({ show: false })}
    >
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${props.formName ? props.formName : "รายการ"}`}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        {FILEDS ? (
          <FormAutoB
            {...{ formId: "form1", items: FILEDS, data: data, refTo: refForm1 }}
          />
        ) : null}
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" onClick={() => saveData()}>
          Save changes
        </Button>
        <Button variant="danger" onClick={() => setWinState({ show: false })}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}

export default UserSettingPopup;
